import { createGlobalStyle } from "styled-components";
import { graiaPrimaryColor } from "./appTheme";

const GlobalStyle = createGlobalStyle`
  :root:root {
    --adm-color-primary: ${graiaPrimaryColor};
  }

  body {
    font-family: ${p => p.theme.fontFamily};
  }

  code {
    font-family: ${p => p.theme.fontFamilyCode};
  }

  .ant-typography {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }

  .adm-toast-mask.failed-outbound-call-toast .adm-toast-main {
    top: 40% !important;
    max-width: 250px;
    background-color: rgba(0, 0, 0, 0.8);
    padding: ${p => p.theme.paddingLG}px;
  }
`;

export default GlobalStyle;
